import { gql } from '__generated__';

export default gql(`
  mutation EditTicketNumber($input: EditPurchaseInput!) {
    editPurchase(input: $input) {
      id
      ticket_number_sequence {
        id
      }
      ticket_number
      ticket_number_locked
    }
  }
`);
